/* eslint-disable */

export interface ApiConfig {
  apiUrl: string
  apiPort: string
}

export function apiConfig(): ApiConfig {
  return {
    apiUrl: import.meta.env.VITE_API_URL || 'VITE_API_URL_undefined',
    apiPort: import.meta.env.VITE_API_PORT || 'VITE_API_PORT_undefined',
  }
}

export interface DefaultConfig {
  envMode: string
  cdnNabu: string
  sentryDsn: string
  clientApiUrl?: string
  catalogUrl?: string
  helpNabu?: string
  mailhookEmailDomain?: string
  tableAutomationsApiUrl?: string
}

export function defaultConfig(): DefaultConfig {
  return {
    envMode: import.meta.env.VITE_NODE_ENV || 'development',
    cdnNabu: import.meta.env.VITE_CDN_NABU,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN || undefined,
    catalogUrl:
      import.meta.env.VITE_CATALOG_URL || 'mldata-catalog.nabu-dev.io',
    helpNabu: import.meta.env.VITE_HELP_NABU || undefined,
    mailhookEmailDomain:
      import.meta.env.VITE_MAILHOOK_EMAIL_DOMAIN || '@email-api.nabu.io',
    tableAutomationsApiUrl:
      import.meta.env.VITE_TABLE_AUTOMATIONS_API_URL || '',
  }
}

export function getClientApiDocsUrl(
  envMode = defaultConfig().envMode
): string {
  if (envMode === 'production') return 'https://client-api.nabu.io/docs'
  if (envMode === 'staging') return 'https://client-api.nabu-staging.io/docs'
  return 'https://client-api.nabu-dev.io/docs'
}
